import { render, staticRenderFns } from "./shuzi.vue?vue&type=template&id=bbf2fe3e"
import script from "./shuzi.vue?vue&type=script&lang=js"
export * from "./shuzi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports